// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Gabarito:wght@400;500;600;700&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  /* Base font sizes using clamp() */
  --font-size-xs: clamp(10px, 2.78vw, 14px);
  --font-size-sm: clamp(12px, 3.33vw, 16px);
  --font-size-md: clamp(14px, 3.89vw, 18px);
  --font-size-lg: clamp(16px, 4.44vw, 20px);
  --font-size-xl: clamp(18px, 5.00vw, 22px);
  --font-size-2xl: clamp(20px, 5.56vw, 24px);
  --font-size-3xl: clamp(24px, 6.67vw, 28px);
  --font-size-4xl: clamp(29px, 8.06vw, 33px);
}

/* Base layout */
.hidden {
    display: none;
  }

html{
  height: 100%;
}  

/* body {
 position: relative;
 z-index: 0;
 height: 100%;
}  

* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
} */

#app-root{
  /* height: 100%; */
}
  
.screen {
    height: 98dvh;
    background: #FFFFFF;
    position: relative;
   }
   

.mascot-signup-screen {
    display: flex;
    justify-content: center;
    position: relative;
  }

.welcome-mascot-text-container, .landing-mascot-text-container {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  transform: translateY(-50%);
}

.welcome-mascot-text-container .dialog-box,
.landing-mascot-text-container .dialog-box {
    position: absolute;
    top: 100%;
  }

  .animated-text{
    font-size: var(--font-size-lg);
    font-weight: 500;
    line-height: 20.8px;
    font-family: 'Gabarito';
  }

   /* Decorative bubbles */
   .bubble-bg {
    position: fixed; 
    width: 100vw;
    height: 100dvh;
   }
   
   .bubble {
    position: absolute;
    background: #95E5E2;
    opacity: 0.15;
    border-radius: 50%;
   }
   
   .bubble-1 { width: 57px; height: 57px; left: 198px; top: 212px; }
   .bubble-2 { width: 25px; height: 25px; left: 39px; top: 216px; }
   .bubble-3 { width: 9px; height: 9px; left: 243px; top: 119px; }
   .bubble-4 { width: 9px; height: 9px; left: 143px; top: 83px; }
   .bubble-5 { width: 75px; height: 75px; left: -24px; top: 92px; }
   .bubble-6 { width: 75px; height: 75px; left: 290px; top: -15px; }
   .bubble-7 { width: 75px; height: 75px; left: -11px; top: 754px; }
   .bubble-8 { width: 19px; height: 19px; left: 91px; top: 738px; }
   
   /* Dialog box */
   .dialog-box {
    max-width: 211px;
    padding: 10px 20px;
    height: auto;
    position: relative;
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    border-radius: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 9%;
   }

   
   .dialog-text {
    font-family: 'Gabarito';
    font-weight: 500;
    font-size: var(--font-size-lg);
    line-height: 130%;
    text-align: center;
    color: #000000;
   }
   
   /* Buttons */
   .button-container {
    position: absolute;
    width: 312px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
    visibility: hidden;
   }

   /* Buttons */
   .first-page-button-container {
    position: absolute;
    width: 312px;
    left: 50%;
    transform: translateX(-50%);
    bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 16px;
   }
   
   .btn {
    width: 100%;
    height: 43px;
    border-radius: 13px;
    font-family: 'Gabarito';
    font-size: var(--font-size-md);
    line-height: 17px;
    text-align: center;
   }
   
   .btn-primary {
    background: #4AC1BD;
    border: 1px solid #25A49F;
    box-shadow: 0px 3px 0px #25A49F;
    color: #FFFFFF;
   }
   
   .btn-secondary {
    background: #FFFFFF;
    border: 1px solid #E4E4E4;
    box-shadow: 0px 3px 0px #E4E4E4;
    color: #000000;
   }

   .clerk-container {
    height: 98vh;
    display: flex;
    justify-content: center;
    align-items: center;
    background: #FFFFFF;
  }





/* //////////// For button group in signup page flow */

/* Transition classes */
.fade {
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.6s ease-in-out, visibility 0.6s ease-in-out;
}

.fade-in {
  opacity: 1;
  visibility: visible;
}

/* Add hover and active states to buttons */
.btn {
  /* Keep existing btn styles */
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.btn:active {
  transform: translateY(2px);
}

/* Optional: Add hover effect */
.btn-primary:hover {
  background: #3DB1AE;
}

.btn-secondary:hover {
  background: #F8F8F8;
}



/* //////////// Navbar styling */

#global-navbar{
  position: relative;
  z-index: 20;
}
.chat-modal-overlay{
  z-index: 100;
}

.chat-full-screen{
  padding: 18px 18px 0px 18px;
  box-sizing: border-box;
  height: 100vh;
}

/* Positions the navbar at the bottom */
   .navbar-fixed {
    position: fixed;
    bottom: 1.5rem; 
    left: 1rem;    
    right: 1rem;
  }
  
  .child-navbar-fixed {
    position: fixed;
    bottom: 1.5rem; 
    left: 1rem;    
    right: 1rem;
    display: flex;
    justify-content:center;
  }

  .child-navbar-container {
    background-color: #fff;                           
    height: 4.5rem;                     
    display: flex;                       
    align-items: center;                 
    justify-content: center;      
    padding: 0.75rem 1rem;
    width: 85%; 
    gap: 20%;

    border: 1px solid #E4E4E4;
    box-shadow: 0px 4px 0px #E4E4E4; 
    border-radius: 20px;
  }

 .child-navbar-icon-group {
  width: 113px;                
  height: 47px;               
  background-color: #4AC1BD;  
  display: flex; 
  align-items: center;        
  justify-content: center; 
  color: white;
  gap: 12px;

  border: 1px solid #25A49F;
  box-shadow: 0px 2px 0px #25A49F;
  border-radius: 12px;
  }

  

  .navbar-container {
    background-color: #fff;              
    border: 1px solid #e5e7eb;           
    border-radius: 1rem;                 
    height: 4.5rem;                     
    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); 
    display: flex;                       
    align-items: center;                 
    justify-content: space-between;      
    padding: 0.75rem 1rem;         
  }
  
  /* The teal box that holds the 2x2 white dots, ~3rem square */
  .navbar-icon-group {
    width: 3rem;                
    height: 3rem;               
    background-color: #4AC1BD;  
    border-radius: 0.75rem;    
    display: flex; 
    align-items: center;        
    justify-content: center;   
  }
  
  /* The grid of four tiny white squares (2x2) inside the teal box */
  .icon-grid {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 0.25rem;  
  }
  
  /* Each dot is 8px x 8px with white bg */
  .dot-white {
    width: 0.5rem;   
    height: 0.5rem;  
    background-color: #fff;
  }
  
  /* The user-button mount, 2rem square */
  .user-button {
    width: 2rem;  
    height: 2rem; 
  }
  
  /* A 1.5rem x 1.5rem gray icon, e.g. for the second SVG */
  .icon-gray {
    width: 1.5rem;  
    height: 1.5rem; 
    fill: #9CA3AF; 
  }
  
  /* Another 1.5rem x 1.5rem circle for pfp */
  .pfp-circle {
    width: 1.5rem;               
    height: 1.5rem;              
    background-color: #e5e7eb;   
    border-radius: 9999px;  
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 0.75rem; 
    color: #333;
  }
  

  /******************************************/
/* Learner Dashboard Topbar (Child View)  */
/******************************************/
.learner-topbar-container {
  margin-top: 3%;
  height: 60px;               /* Adjust to your liking */
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 20; /* Sit on top */
  padding: 0 1rem; 
}

/* Left side: e.g. hamburger icon */
.learner-topbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Right side: e.g. octopus icon and smiley icon placeholders */
.learner-topbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/******************************************/
/* Parent Dashboard Topbar (Parent View)  */
/******************************************/
.parent-topbar-fixed {
  position: relative;
  height: 60px;
  background: #FFFFFF;
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 20;
  padding: 0 1rem;
  margin-top: 3%;
}

.hamburger-button {
  width: 45px;
  height: 45px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 4px 0px #E4E4E4;
}

/* Left side: e.g. hamburger icon, or any other elements */
.parent-topbar-left {
  display: flex;
  align-items: center;
  gap: 1rem;
}

/* Right side: e.g. user button, or other icons */
.parent-topbar-right {
  display: flex;
  align-items: center;
  gap: 1rem;
}


/* /////////////// Styling for Custom signin Pages */
/* Base styles */
.screen {
  position: relative;
  width: 360px;
  height: 98dvh;
  background: #FFFFFF;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

/* Mascot styles */
.mascot-signup-options-screen {
  position: relative;
  width: 100px;
  height: 93.67px;
  margin-bottom: 22px;
}

/* Dialog box styles */
.dialog-box-signup {
  position: relative;
  margin-bottom: 22px;
  text-align: center;
}

.dialog-text-signup {
  font-family: 'Gabarito';
  font-style: normal;
  font-weight: 600;
  font-size: var(--font-size-3xl);
  line-height: 29px;
  color: #000000;
  margin: 0;
}

.signin-button-logo{
  margin-right: 0px;
  border: 2px dolid red;
}


/* Button container styles */
.first-page-signin-button-container,
.button-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
  width: 312px;
}

/* Button styles */
.btn {
  width: 100%;
  height: 43px;
  border-radius: 13px;
  font-family: 'Gabarito';
  font-style: normal;
  font-weight: 400;
  font-size: var(--font-size-md);
  line-height: 17px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  border: none;
}

.btn-primary {
  background: #4AC1BD;
  border: 1px solid #25A49F;
  box-shadow: 0px 3px 0px #25A49F;
  color: #FFFFFF;
}

.btn-secondary {
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  box-shadow: 0px 3px 0px #E4E4E4;
  color: #000000;
}

/* Sign in screen specific styles */
.email-sign-in-page,
.phone-sign-in-page {
  position: relative;
  width: 85%;
  max-width: 314px;
  margin: 0 auto;
  padding-top: 4px;
}

.signin-back-button {
  position: absolute;
  width: 45px;
  height: 45px;
  left: 16px;
  top: 20px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 4px 0px #E4E4E4;
}

/* Sign in screen specific styles */
.email-sign-up-page,
.phone-sign-up-page {
  position: relative;
  width: 85%;
  max-width: 314px;
  margin: 0 auto;
  padding-top: 4px;
}

.signup-back-button {
  position: absolute;
  width: 45px;
  height: 45px;
  left: 16px;
  top: 20px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  box-shadow: 0px 4px 0px #E4E4E4;
}

/* Input field styles */
.input-group {
  margin-bottom: 20px;
  max-width: 312px;
}

.input-label {
  font-family: 'Gabarito';
  font-style: normal;
  font-weight: 500;
  font-size: var(--font-size-md);
  line-height: 17px;
  color: #000000;
  margin-bottom: 10px;
}

.input-field {
  width: 100%;
  height: 43px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  box-shadow: 0px 3px 0px #E4E4E4;
  border-radius: 13px;
  padding: 0 15px;
  font-family: 'Gabarito';
  font-size: var(--font-size-md);
}

.input-field::placeholder {
  color: #C5C5C5;
}

/* Forgot password link */
.forgot-password {
  font-family: 'Gabarito';
  font-style: normal;
  font-weight: 400;
  font-size: var(--font-size-sm);
  line-height: 14px;
  text-align: right;
  color: #000000;
  text-decoration: none;
  display: block;
  margin-top: 10px;
}
/* Sign in screen specific styles */
.password-reset-form {
  position: relative;
  width: 85%;
  max-width: 314px;
  margin: 0 auto;
  padding-top: 4px;
}

/* Create account link */
.create-account-link {
  position: fixed;
  bottom: 2%;
  font-family: 'Gabarito';
  font-style: normal;
  font-weight: 400;
  font-size: var(--font-size-md);
  line-height: 17px;
  text-align: center;
  color: #A0A0A0;
  text-decoration: none;
  margin-top: 20px;
  display: block;
}

.create-account-link span {
  color: #4AC1BD;
}

/* Animation classes */
.hidden {
  display: none;
}

.fade-in {
  opacity: 0;
  animation: fadeIn 0.5s ease-in forwards;
}

@keyframes fadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Icon positioning */
.icon-left {
  position: absolute;
  left: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.icon-right {
  position: absolute;
  right: 15px;
  top: 50%;
  transform: translateY(-50%);
}

.loading-in-dashboard{
  width: 100%;
  height: 80vh;
  display: flex;
  align-items:center;
  justify-content: center;
}


/* //////////////////// Chat co-pilot avatar */
/* Mascot styles */
.mascot-icon {
  cursor: pointer;
  position: relative;
  transition: transform 0.2s ease;
 }
 
 .mascot-icon:hover {
  transform: scale(1.05);
 }
 
 .mascot-message {
  position: absolute;
  display: flex;
  bottom: 80px; 
  right: 20px;
  gap: 10px;
  color: #FFFFFF;
  background-color: transparent;
  font-size: var(--font-size-sm);
  max-width: 240px;
  z-index: 100;
  animation: slideUp 0.3s ease;
 }
 
 .copilot-message-text {
  background-color: #4AC1BD;
  padding:10px 10px;
  border-radius: 6px;
  
 }
 
 .message-close {
  position: relative;
  background: none;
  border: none;
  background-color: #4AC1BD;
  cursor: pointer;
  padding: 0px 12px 0px 12px;
  border-radius: 6px;
 }
 
 .message-close:hover {
  background: rgba(0,0,0,0.05);
 }
 
 @keyframes slideUp {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
 }


 /* ////////////////  Profile Swith Popup */

 .profile-modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.profile-options-container {
  position: relative;
  width: 285px;
  max-height: 305px;
  background: #FFFFFF;
  border: 1px solid #E9E9E9;
  box-shadow: 0px 4px 0px #E9E9E9;
  border-radius: 15px;
  padding: 20px 20px 35px 20px;
}

.close-button-switch-popup {
  position: absolute;
  right: 16px;
  top: 12px;
  background: none;
  border: none;
  cursor: pointer;
}

.profile-options-title {
  text-align: center;
  font-size: var(--font-size-2xl);
  font-weight: 600;
  margin-top: 12px;
  font-family: 'Gabarito';
}

.profile-options-subtitle {
  text-align: center;
  font-size: var(--font-size-md);
  color: #AAAAAA;
  font-family: 'Gabarito';
}

.profile-options-buttons {
  display: flex;
  gap: 12px;
  margin-top: 24px;
}

.profile-child-button {
  flex: 1;
  height: 48px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  box-shadow: 0px 3px 0px #E4E4E4;
  border-radius: 13px;
  display: flex;
  align-items: center;
  padding: 0 8px;
  cursor: pointer;
}

.child-avatar {
  width: 35px;
  height: 35px;
  border-radius: 50%;
  margin-right: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.harvey {
  background: #91D159;
}

.donna {
  background: #FFB61D;
}

.avatar-inner {
  width: 20px;
  height: 20px;
  background: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.avatar-dot {
  width: 8px;
  height: 8px;
  background: black;
  border-radius: 50%;
}

.avatar-inner-donna {
  width: 22px;
  height: 22px;
  background: white;
  transform: rotate(45deg);
}

.profile-options-divider {
  display: flex;
  align-items: center;
  justify-content: center;
  margin-top: 18px;
  margin-bottom: 14px;
}

.divider-line {
  width: 95px;
  height: 1px;
  background: #EEEEEE;
}

.profile-options-divider .or-view {
  margin: 0 8px;
  color: #AAAAAA;
  font-size: var(--font-size-md);
  font-family: 'Gabarito';
  min-width: 55px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.profile-parent-button {
  width: 100%;
  height: 48px;
  background: #FFFFFF;
  border: 1px solid #E4E4E4;
  box-shadow: 0px 3px 0px #E4E4E4;
  border-radius: 13px;
  display: flex;
  align-items: center;
  padding: 0 16px;
  cursor: pointer;
}

.parent-avatar {
  width: 31px;
  height: 31px;
  border-radius: 50%;
  background: #C5FFFD;
  margin-right: 12px;
}

.welcome-button-container {
  opacity: 0;
  transition: opacity 0.5s ease-in;
}

.welcome-button-container.fade-in {
  opacity: 1;
}
`, "",{"version":3,"sources":["webpack://./src/style.css"],"names":[],"mappings":"AAEA;EACE,kCAAkC;EAClC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,yCAAyC;EACzC,0CAA0C;EAC1C,0CAA0C;EAC1C,0CAA0C;AAC5C;;AAEA,gBAAgB;AAChB;IACI,aAAa;EACf;;AAEF;EACE,YAAY;AACd;;AAEA;;;;;;;;;;GAUG;;AAEH;EACE,kBAAkB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;GACnB;;;AAGH;IACI,aAAa;IACb,uBAAuB;IACvB,kBAAkB;EACpB;;AAEF;EACE,kBAAkB;EAClB,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;;IAEI,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,8BAA8B;IAC9B,gBAAgB;IAChB,mBAAmB;IACnB,uBAAuB;EACzB;;GAEC,uBAAuB;GACvB;IACC,eAAe;IACf,YAAY;IACZ,cAAc;GACf;;GAEA;IACC,kBAAkB;IAClB,mBAAmB;IACnB,aAAa;IACb,kBAAkB;GACnB;;GAEA,YAAY,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE;GAChE,YAAY,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,UAAU,EAAE;GAC/D,YAAY,UAAU,EAAE,WAAW,EAAE,WAAW,EAAE,UAAU,EAAE;GAC9D,YAAY,UAAU,EAAE,WAAW,EAAE,WAAW,EAAE,SAAS,EAAE;GAC7D,YAAY,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,SAAS,EAAE;GAC/D,YAAY,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE;GAChE,YAAY,WAAW,EAAE,YAAY,EAAE,WAAW,EAAE,UAAU,EAAE;GAChE,YAAY,WAAW,EAAE,YAAY,EAAE,UAAU,EAAE,UAAU,EAAE;;GAE/D,eAAe;GACf;IACC,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;GACf;;;GAGA;IACC,uBAAuB;IACvB,gBAAgB;IAChB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;IAClB,cAAc;GACf;;GAEA,YAAY;GACZ;IACC,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,kBAAkB;GACnB;;GAEA,YAAY;GACZ;IACC,kBAAkB;IAClB,YAAY;IACZ,SAAS;IACT,2BAA2B;IAC3B,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,SAAS;GACV;;GAEA;IACC,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,uBAAuB;IACvB,8BAA8B;IAC9B,iBAAiB;IACjB,kBAAkB;GACnB;;GAEA;IACC,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;GACf;;GAEA;IACC,mBAAmB;IACnB,yBAAyB;IACzB,+BAA+B;IAC/B,cAAc;GACf;;GAEA;IACC,YAAY;IACZ,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,mBAAmB;EACrB;;;;;;AAMF,sDAAsD;;AAEtD,uBAAuB;AACvB;EACE,UAAU;EACV,kBAAkB;EAClB,iEAAiE;AACnE;;AAEA;EACE,UAAU;EACV,mBAAmB;AACrB;;AAEA,2CAA2C;AAC3C;EACE,6BAA6B;EAC7B,qDAAqD;AACvD;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;;;AAIA,gCAAgC;;AAEhC;EACE,kBAAkB;EAClB,WAAW;AACb;AACA;EACE,YAAY;AACd;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;EACtB,aAAa;AACf;;AAEA,uCAAuC;GACpC;IACC,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;EACb;;EAEA;IACE,eAAe;IACf,cAAc;IACd,UAAU;IACV,WAAW;IACX,aAAa;IACb,sBAAsB;EACxB;;EAEA;IACE,sBAAsB;IACtB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,UAAU;IACV,QAAQ;;IAER,yBAAyB;IACzB,+BAA+B;IAC/B,mBAAmB;EACrB;;CAED;EACC,YAAY;EACZ,YAAY;EACZ,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,SAAS;;EAET,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB;;;;EAIA;IACE,sBAAsB;IACtB,yBAAyB;IACzB,mBAAmB;IACnB,cAAc;IACd,yCAAyC;IACzC,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA,6DAA6D;EAC7D;IACE,WAAW;IACX,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;IACtB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA,kEAAkE;EAClE;IACE,aAAa;IACb,qCAAqC;IACrC,YAAY;EACd;;EAEA,wCAAwC;EACxC;IACE,aAAa;IACb,cAAc;IACd,sBAAsB;EACxB;;EAEA,uCAAuC;EACvC;IACE,WAAW;IACX,YAAY;EACd;;EAEA,yDAAyD;EACzD;IACE,aAAa;IACb,cAAc;IACd,aAAa;EACf;;EAEA,2CAA2C;EAC3C;IACE,aAAa;IACb,cAAc;IACd,yBAAyB;IACzB,qBAAqB;IACrB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kBAAkB;IAClB,WAAW;EACb;;;EAGA,2CAA2C;AAC7C,2CAA2C;AAC3C,2CAA2C;AAC3C;EACE,cAAc;EACd,YAAY,gBAAgB,0BAA0B;EACtD,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW,EAAE,eAAe;EAC5B,eAAe;AACjB;;AAEA,mCAAmC;AACnC;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,+DAA+D;AAC/D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,2CAA2C;AAC3C,2CAA2C;AAC3C,2CAA2C;AAC3C;EACE,kBAAkB;EAClB,YAAY;EACZ,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;EACX,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA,0DAA0D;AAC1D;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA,iDAAiD;AACjD;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;;AAGA,oDAAoD;AACpD,gBAAgB;AAChB;EACE,kBAAkB;EAClB,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,YAAY;EACZ,eAAe;EACf,mBAAmB;AACrB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,+BAA+B;EAC/B,iBAAiB;EACjB,cAAc;EACd,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;;AAGA,4BAA4B;AAC5B;;EAEE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,YAAY;AACd;;AAEA,kBAAkB;AAClB;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,cAAc;AAChB;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA,mCAAmC;AACnC;;EAEE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,UAAU;EACV,SAAS;EACT,mBAAmB;EACnB,yBAAyB;EACzB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,+BAA+B;AACjC;;AAEA,uBAAuB;AACvB;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,cAAc;EACd,gBAAgB;AAClB;AACA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA,wBAAwB;AACxB;EACE,eAAe;EACf,UAAU;EACV,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,8BAA8B;EAC9B,iBAAiB;EACjB,kBAAkB;EAClB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,sBAAsB;AACtB;EACE,aAAa;AACf;;AAEA;EACE,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,kBAAkB;EAClB,uBAAuB;AACzB;;;AAGA,8CAA8C;AAC9C,kBAAkB;AAClB;EACE,eAAe;EACf,kBAAkB;EAClB,+BAA+B;CAChC;;CAEA;EACC,sBAAsB;CACvB;;CAEA;EACC,kBAAkB;EAClB,aAAa;EACb,YAAY;EACZ,WAAW;EACX,SAAS;EACT,cAAc;EACd,6BAA6B;EAC7B,8BAA8B;EAC9B,gBAAgB;EAChB,YAAY;EACZ,4BAA4B;CAC7B;;CAEA;EACC,yBAAyB;EACzB,iBAAiB;EACjB,kBAAkB;;CAEnB;;CAEA;EACC,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,0BAA0B;EAC1B,kBAAkB;CACnB;;CAEA;EACC,4BAA4B;CAC7B;;CAEA;EACC;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;CACD;;;CAGA,0CAA0C;;CAE1C;EACC,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,8BAA8B;EAC9B,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,SAAS;EACT,gBAAgB;EAChB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,OAAO;EACP,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,cAAc;EACd,8BAA8B;EAC9B,uBAAuB;EACvB,eAAe;EACf,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,yBAAyB;EACzB,+BAA+B;EAC/B,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,gCAAgC;AAClC;;AAEA;EACE,UAAU;AACZ","sourcesContent":["@import url('https://fonts.googleapis.com/css2?family=Gabarito:wght@400;500;600;700&display=swap');\n\n:root {\n  /* Base font sizes using clamp() */\n  --font-size-xs: clamp(10px, 2.78vw, 14px);\n  --font-size-sm: clamp(12px, 3.33vw, 16px);\n  --font-size-md: clamp(14px, 3.89vw, 18px);\n  --font-size-lg: clamp(16px, 4.44vw, 20px);\n  --font-size-xl: clamp(18px, 5.00vw, 22px);\n  --font-size-2xl: clamp(20px, 5.56vw, 24px);\n  --font-size-3xl: clamp(24px, 6.67vw, 28px);\n  --font-size-4xl: clamp(29px, 8.06vw, 33px);\n}\n\n/* Base layout */\n.hidden {\n    display: none;\n  }\n\nhtml{\n  height: 100%;\n}  \n\n/* body {\n position: relative;\n z-index: 0;\n height: 100%;\n}  \n\n* {\n  box-sizing: border-box;\n  margin: 0;\n  padding: 0;\n} */\n\n#app-root{\n  /* height: 100%; */\n}\n  \n.screen {\n    height: 98dvh;\n    background: #FFFFFF;\n    position: relative;\n   }\n   \n\n.mascot-signup-screen {\n    display: flex;\n    justify-content: center;\n    position: relative;\n  }\n\n.welcome-mascot-text-container, .landing-mascot-text-container {\n  position: relative;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: translateY(-50%);\n}\n\n.welcome-mascot-text-container .dialog-box,\n.landing-mascot-text-container .dialog-box {\n    position: absolute;\n    top: 100%;\n  }\n\n  .animated-text{\n    font-size: var(--font-size-lg);\n    font-weight: 500;\n    line-height: 20.8px;\n    font-family: 'Gabarito';\n  }\n\n   /* Decorative bubbles */\n   .bubble-bg {\n    position: fixed; \n    width: 100vw;\n    height: 100dvh;\n   }\n   \n   .bubble {\n    position: absolute;\n    background: #95E5E2;\n    opacity: 0.15;\n    border-radius: 50%;\n   }\n   \n   .bubble-1 { width: 57px; height: 57px; left: 198px; top: 212px; }\n   .bubble-2 { width: 25px; height: 25px; left: 39px; top: 216px; }\n   .bubble-3 { width: 9px; height: 9px; left: 243px; top: 119px; }\n   .bubble-4 { width: 9px; height: 9px; left: 143px; top: 83px; }\n   .bubble-5 { width: 75px; height: 75px; left: -24px; top: 92px; }\n   .bubble-6 { width: 75px; height: 75px; left: 290px; top: -15px; }\n   .bubble-7 { width: 75px; height: 75px; left: -11px; top: 754px; }\n   .bubble-8 { width: 19px; height: 19px; left: 91px; top: 738px; }\n   \n   /* Dialog box */\n   .dialog-box {\n    max-width: 211px;\n    padding: 10px 20px;\n    height: auto;\n    position: relative;\n    background: #FFFFFF;\n    border: 1px solid #E4E4E4;\n    border-radius: 12px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: 9%;\n   }\n\n   \n   .dialog-text {\n    font-family: 'Gabarito';\n    font-weight: 500;\n    font-size: var(--font-size-lg);\n    line-height: 130%;\n    text-align: center;\n    color: #000000;\n   }\n   \n   /* Buttons */\n   .button-container {\n    position: absolute;\n    width: 312px;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n    visibility: hidden;\n   }\n\n   /* Buttons */\n   .first-page-button-container {\n    position: absolute;\n    width: 312px;\n    left: 50%;\n    transform: translateX(-50%);\n    bottom: 24px;\n    display: flex;\n    flex-direction: column;\n    gap: 16px;\n   }\n   \n   .btn {\n    width: 100%;\n    height: 43px;\n    border-radius: 13px;\n    font-family: 'Gabarito';\n    font-size: var(--font-size-md);\n    line-height: 17px;\n    text-align: center;\n   }\n   \n   .btn-primary {\n    background: #4AC1BD;\n    border: 1px solid #25A49F;\n    box-shadow: 0px 3px 0px #25A49F;\n    color: #FFFFFF;\n   }\n   \n   .btn-secondary {\n    background: #FFFFFF;\n    border: 1px solid #E4E4E4;\n    box-shadow: 0px 3px 0px #E4E4E4;\n    color: #000000;\n   }\n\n   .clerk-container {\n    height: 98vh;\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    background: #FFFFFF;\n  }\n\n\n\n\n\n/* //////////// For button group in signup page flow */\n\n/* Transition classes */\n.fade {\n  opacity: 0;\n  visibility: hidden;\n  transition: opacity 0.6s ease-in-out, visibility 0.6s ease-in-out;\n}\n\n.fade-in {\n  opacity: 1;\n  visibility: visible;\n}\n\n/* Add hover and active states to buttons */\n.btn {\n  /* Keep existing btn styles */\n  transition: transform 0.2s ease, box-shadow 0.2s ease;\n}\n\n.btn:active {\n  transform: translateY(2px);\n}\n\n/* Optional: Add hover effect */\n.btn-primary:hover {\n  background: #3DB1AE;\n}\n\n.btn-secondary:hover {\n  background: #F8F8F8;\n}\n\n\n\n/* //////////// Navbar styling */\n\n#global-navbar{\n  position: relative;\n  z-index: 20;\n}\n.chat-modal-overlay{\n  z-index: 100;\n}\n\n.chat-full-screen{\n  padding: 18px 18px 0px 18px;\n  box-sizing: border-box;\n  height: 100vh;\n}\n\n/* Positions the navbar at the bottom */\n   .navbar-fixed {\n    position: fixed;\n    bottom: 1.5rem; \n    left: 1rem;    \n    right: 1rem;\n  }\n  \n  .child-navbar-fixed {\n    position: fixed;\n    bottom: 1.5rem; \n    left: 1rem;    \n    right: 1rem;\n    display: flex;\n    justify-content:center;\n  }\n\n  .child-navbar-container {\n    background-color: #fff;                           \n    height: 4.5rem;                     \n    display: flex;                       \n    align-items: center;                 \n    justify-content: center;      \n    padding: 0.75rem 1rem;\n    width: 85%; \n    gap: 20%;\n\n    border: 1px solid #E4E4E4;\n    box-shadow: 0px 4px 0px #E4E4E4; \n    border-radius: 20px;\n  }\n\n .child-navbar-icon-group {\n  width: 113px;                \n  height: 47px;               \n  background-color: #4AC1BD;  \n  display: flex; \n  align-items: center;        \n  justify-content: center; \n  color: white;\n  gap: 12px;\n\n  border: 1px solid #25A49F;\n  box-shadow: 0px 2px 0px #25A49F;\n  border-radius: 12px;\n  }\n\n  \n\n  .navbar-container {\n    background-color: #fff;              \n    border: 1px solid #e5e7eb;           \n    border-radius: 1rem;                 \n    height: 4.5rem;                     \n    box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05); \n    display: flex;                       \n    align-items: center;                 \n    justify-content: space-between;      \n    padding: 0.75rem 1rem;         \n  }\n  \n  /* The teal box that holds the 2x2 white dots, ~3rem square */\n  .navbar-icon-group {\n    width: 3rem;                \n    height: 3rem;               \n    background-color: #4AC1BD;  \n    border-radius: 0.75rem;    \n    display: flex; \n    align-items: center;        \n    justify-content: center;   \n  }\n  \n  /* The grid of four tiny white squares (2x2) inside the teal box */\n  .icon-grid {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 0.25rem;  \n  }\n  \n  /* Each dot is 8px x 8px with white bg */\n  .dot-white {\n    width: 0.5rem;   \n    height: 0.5rem;  \n    background-color: #fff;\n  }\n  \n  /* The user-button mount, 2rem square */\n  .user-button {\n    width: 2rem;  \n    height: 2rem; \n  }\n  \n  /* A 1.5rem x 1.5rem gray icon, e.g. for the second SVG */\n  .icon-gray {\n    width: 1.5rem;  \n    height: 1.5rem; \n    fill: #9CA3AF; \n  }\n  \n  /* Another 1.5rem x 1.5rem circle for pfp */\n  .pfp-circle {\n    width: 1.5rem;               \n    height: 1.5rem;              \n    background-color: #e5e7eb;   \n    border-radius: 9999px;  \n    display: flex;\n    align-items: center;\n    justify-content: center;\n    font-size: 0.75rem; \n    color: #333;\n  }\n  \n\n  /******************************************/\n/* Learner Dashboard Topbar (Child View)  */\n/******************************************/\n.learner-topbar-container {\n  margin-top: 3%;\n  height: 60px;               /* Adjust to your liking */\n  background: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 20; /* Sit on top */\n  padding: 0 1rem; \n}\n\n/* Left side: e.g. hamburger icon */\n.learner-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Right side: e.g. octopus icon and smiley icon placeholders */\n.learner-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/******************************************/\n/* Parent Dashboard Topbar (Parent View)  */\n/******************************************/\n.parent-topbar-fixed {\n  position: relative;\n  height: 60px;\n  background: #FFFFFF;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  z-index: 20;\n  padding: 0 1rem;\n  margin-top: 3%;\n}\n\n.hamburger-button {\n  width: 45px;\n  height: 45px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0px 4px 0px #E4E4E4;\n}\n\n/* Left side: e.g. hamburger icon, or any other elements */\n.parent-topbar-left {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n/* Right side: e.g. user button, or other icons */\n.parent-topbar-right {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n\n/* /////////////// Styling for Custom signin Pages */\n/* Base styles */\n.screen {\n  position: relative;\n  width: 360px;\n  height: 98dvh;\n  background: #FFFFFF;\n  margin: 0 auto;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n}\n\n/* Mascot styles */\n.mascot-signup-options-screen {\n  position: relative;\n  width: 100px;\n  height: 93.67px;\n  margin-bottom: 22px;\n}\n\n/* Dialog box styles */\n.dialog-box-signup {\n  position: relative;\n  margin-bottom: 22px;\n  text-align: center;\n}\n\n.dialog-text-signup {\n  font-family: 'Gabarito';\n  font-style: normal;\n  font-weight: 600;\n  font-size: var(--font-size-3xl);\n  line-height: 29px;\n  color: #000000;\n  margin: 0;\n}\n\n.signin-button-logo{\n  margin-right: 0px;\n  border: 2px dolid red;\n}\n\n\n/* Button container styles */\n.first-page-signin-button-container,\n.button-container {\n  display: flex;\n  flex-direction: column;\n  gap: 15px;\n  width: 312px;\n}\n\n/* Button styles */\n.btn {\n  width: 100%;\n  height: 43px;\n  border-radius: 13px;\n  font-family: 'Gabarito';\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--font-size-md);\n  line-height: 17px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  border: none;\n}\n\n.btn-primary {\n  background: #4AC1BD;\n  border: 1px solid #25A49F;\n  box-shadow: 0px 3px 0px #25A49F;\n  color: #FFFFFF;\n}\n\n.btn-secondary {\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  box-shadow: 0px 3px 0px #E4E4E4;\n  color: #000000;\n}\n\n/* Sign in screen specific styles */\n.email-sign-in-page,\n.phone-sign-in-page {\n  position: relative;\n  width: 85%;\n  max-width: 314px;\n  margin: 0 auto;\n  padding-top: 4px;\n}\n\n.signin-back-button {\n  position: absolute;\n  width: 45px;\n  height: 45px;\n  left: 16px;\n  top: 20px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0px 4px 0px #E4E4E4;\n}\n\n/* Sign in screen specific styles */\n.email-sign-up-page,\n.phone-sign-up-page {\n  position: relative;\n  width: 85%;\n  max-width: 314px;\n  margin: 0 auto;\n  padding-top: 4px;\n}\n\n.signup-back-button {\n  position: absolute;\n  width: 45px;\n  height: 45px;\n  left: 16px;\n  top: 20px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  box-shadow: 0px 4px 0px #E4E4E4;\n}\n\n/* Input field styles */\n.input-group {\n  margin-bottom: 20px;\n  max-width: 312px;\n}\n\n.input-label {\n  font-family: 'Gabarito';\n  font-style: normal;\n  font-weight: 500;\n  font-size: var(--font-size-md);\n  line-height: 17px;\n  color: #000000;\n  margin-bottom: 10px;\n}\n\n.input-field {\n  width: 100%;\n  height: 43px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  box-shadow: 0px 3px 0px #E4E4E4;\n  border-radius: 13px;\n  padding: 0 15px;\n  font-family: 'Gabarito';\n  font-size: var(--font-size-md);\n}\n\n.input-field::placeholder {\n  color: #C5C5C5;\n}\n\n/* Forgot password link */\n.forgot-password {\n  font-family: 'Gabarito';\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--font-size-sm);\n  line-height: 14px;\n  text-align: right;\n  color: #000000;\n  text-decoration: none;\n  display: block;\n  margin-top: 10px;\n}\n/* Sign in screen specific styles */\n.password-reset-form {\n  position: relative;\n  width: 85%;\n  max-width: 314px;\n  margin: 0 auto;\n  padding-top: 4px;\n}\n\n/* Create account link */\n.create-account-link {\n  position: fixed;\n  bottom: 2%;\n  font-family: 'Gabarito';\n  font-style: normal;\n  font-weight: 400;\n  font-size: var(--font-size-md);\n  line-height: 17px;\n  text-align: center;\n  color: #A0A0A0;\n  text-decoration: none;\n  margin-top: 20px;\n  display: block;\n}\n\n.create-account-link span {\n  color: #4AC1BD;\n}\n\n/* Animation classes */\n.hidden {\n  display: none;\n}\n\n.fade-in {\n  opacity: 0;\n  animation: fadeIn 0.5s ease-in forwards;\n}\n\n@keyframes fadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Icon positioning */\n.icon-left {\n  position: absolute;\n  left: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.icon-right {\n  position: absolute;\n  right: 15px;\n  top: 50%;\n  transform: translateY(-50%);\n}\n\n.loading-in-dashboard{\n  width: 100%;\n  height: 80vh;\n  display: flex;\n  align-items:center;\n  justify-content: center;\n}\n\n\n/* //////////////////// Chat co-pilot avatar */\n/* Mascot styles */\n.mascot-icon {\n  cursor: pointer;\n  position: relative;\n  transition: transform 0.2s ease;\n }\n \n .mascot-icon:hover {\n  transform: scale(1.05);\n }\n \n .mascot-message {\n  position: absolute;\n  display: flex;\n  bottom: 80px; \n  right: 20px;\n  gap: 10px;\n  color: #FFFFFF;\n  background-color: transparent;\n  font-size: var(--font-size-sm);\n  max-width: 240px;\n  z-index: 100;\n  animation: slideUp 0.3s ease;\n }\n \n .copilot-message-text {\n  background-color: #4AC1BD;\n  padding:10px 10px;\n  border-radius: 6px;\n  \n }\n \n .message-close {\n  position: relative;\n  background: none;\n  border: none;\n  background-color: #4AC1BD;\n  cursor: pointer;\n  padding: 0px 12px 0px 12px;\n  border-radius: 6px;\n }\n \n .message-close:hover {\n  background: rgba(0,0,0,0.05);\n }\n \n @keyframes slideUp {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n }\n\n\n /* ////////////////  Profile Swith Popup */\n\n .profile-modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(0, 0, 0, 0.3);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 1000;\n}\n\n.profile-options-container {\n  position: relative;\n  width: 285px;\n  max-height: 305px;\n  background: #FFFFFF;\n  border: 1px solid #E9E9E9;\n  box-shadow: 0px 4px 0px #E9E9E9;\n  border-radius: 15px;\n  padding: 20px 20px 35px 20px;\n}\n\n.close-button-switch-popup {\n  position: absolute;\n  right: 16px;\n  top: 12px;\n  background: none;\n  border: none;\n  cursor: pointer;\n}\n\n.profile-options-title {\n  text-align: center;\n  font-size: var(--font-size-2xl);\n  font-weight: 600;\n  margin-top: 12px;\n  font-family: 'Gabarito';\n}\n\n.profile-options-subtitle {\n  text-align: center;\n  font-size: var(--font-size-md);\n  color: #AAAAAA;\n  font-family: 'Gabarito';\n}\n\n.profile-options-buttons {\n  display: flex;\n  gap: 12px;\n  margin-top: 24px;\n}\n\n.profile-child-button {\n  flex: 1;\n  height: 48px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  box-shadow: 0px 3px 0px #E4E4E4;\n  border-radius: 13px;\n  display: flex;\n  align-items: center;\n  padding: 0 8px;\n  cursor: pointer;\n}\n\n.child-avatar {\n  width: 35px;\n  height: 35px;\n  border-radius: 50%;\n  margin-right: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.harvey {\n  background: #91D159;\n}\n\n.donna {\n  background: #FFB61D;\n}\n\n.avatar-inner {\n  width: 20px;\n  height: 20px;\n  background: white;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.avatar-dot {\n  width: 8px;\n  height: 8px;\n  background: black;\n  border-radius: 50%;\n}\n\n.avatar-inner-donna {\n  width: 22px;\n  height: 22px;\n  background: white;\n  transform: rotate(45deg);\n}\n\n.profile-options-divider {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin-top: 18px;\n  margin-bottom: 14px;\n}\n\n.divider-line {\n  width: 95px;\n  height: 1px;\n  background: #EEEEEE;\n}\n\n.profile-options-divider .or-view {\n  margin: 0 8px;\n  color: #AAAAAA;\n  font-size: var(--font-size-md);\n  font-family: 'Gabarito';\n  min-width: 55px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.profile-parent-button {\n  width: 100%;\n  height: 48px;\n  background: #FFFFFF;\n  border: 1px solid #E4E4E4;\n  box-shadow: 0px 3px 0px #E4E4E4;\n  border-radius: 13px;\n  display: flex;\n  align-items: center;\n  padding: 0 16px;\n  cursor: pointer;\n}\n\n.parent-avatar {\n  width: 31px;\n  height: 31px;\n  border-radius: 50%;\n  background: #C5FFFD;\n  margin-right: 12px;\n}\n\n.welcome-button-container {\n  opacity: 0;\n  transition: opacity 0.5s ease-in;\n}\n\n.welcome-button-container.fade-in {\n  opacity: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
